<template>
    <span>
        <ol class="breadcrumbs d-sm-none d-md-inline">
            <li :class="'breadcrumbs-item' + (index == items.length-1 ? ' active' : '')" v-for="(item, index) in items" :key="item">
                <span aria-current="location">{{ item }}</span>
            </li>
        </ol>
        <span class="breadcrumbs d-sm-inline-block d-md-none" v-if="showOnMobile">
            <li class="breadcrumbs-item active">
                <span aria-current="location">
                    <app-long-text :maxLength="15" :text="items[items.length-1]" />
                </span>
            </li>
        </span>
    </span>
</template>

<script>
import FunctionInfo from '@/models/Core/FunctionInfo';
export default {
    data() {
      return {
        items: [],
        routeName : {
            "homeindex" : "Home",
        },
      }
    },
    props: {
        showOnMobile: {
            default: true
        },
    },
    methods : {
        
    },
    mounted() {
    },
    watch : {
        currentPage() {
            var path = this.$route.path;
            path = path.replace(/[\/]/g, "");
            let result = FunctionInfo.query().where('uri', path).with("moduleInfo").first();
            if (result != null) {
                let functionName = result.name;
                let moduleName = result.moduleInfo ? result.moduleInfo.name : "Master Data";
                this.items = [moduleName, functionName];
            } else {
                this.items = this.$store.state.breadcrumbs;
            }
        },
    },
    computed : {
        currentPage() {
            return this.$store.state.breadcrumbs;
        },
        getBreadcrumbsItem() {
            var items = [
                {
                    text: 'Home',
                    to: '/'
                },
                
            ];
            var itemRoutes = this.routeName[this.$route.name];
            if (Array.isArray(itemRoutes)) {
                itemRoutes.forEach(route => {
                    var item = {};
                    if (route.href != undefined) {
                        item = {
                            text: route.name,
                            to: route.href
                        };
                    } else {
                        item = {
                            text: route,
                            active: true
                        };
                    }
                    
                    items.push(item);
                });
            } else {
                var item = {
                    text: this.routeName[this.$route.name],
                    active: true
                };
                items.push(item);
            }
            return items;
        },
        showBreadcrumb() {
            var show = true;
            if (this.$route.name == 'home') {
                show = false;
            }
            return show;
        }
    }
  }
</script>